exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-spinner {\n  position: absolute;\n  pointer-events: none;\n  display: flex !important;\n  height: 50vh;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 1rem;\n  color: #1ab394;\n  transition: opacity 1s ease-in-out;\n}\n.progress {\n  width: 50%;\n}", ""]);

